import React from 'react'
import { SVGIconProps } from '../types'
const SvgAddBusiness = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M15 17h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4zm-6 1H4v-4h5zM2 4h15v2H2z" />
    <path d="M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2z" />
  </svg>
)
export default SvgAddBusiness
